export default "__VITE_ASSET__BvWLyoAE__"